import React from 'react'
import LeaderBoardSub from '../components/LeaderBoardSub'

const LeaderBoard = () => {
  return (
    <>
    
    <LeaderBoardSub/>
    
    </>
  )
}

export default LeaderBoard